import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { MobileMediaField } from '../../backbone/shared/models/MobileMediaField';
import { resizeImage } from '../../shared/utils/files';
import { BaseZenputModel } from '../shared/forms';
import { createUUID } from '../utils/files';
import { ZenputFiles } from '../../backbone/shared/models/files';

const MAX_SIZE = 2048;

export const FollowUpAction = BaseZenputModel.extend({
    defaults: {
        assigned_user: null,
        completed_user: null,
        created_user: null,
        data: null,
        date_assigned: null,
        date_completed: null,
        date_created: null,
        date_deleted: null,
        date_due: null,
        deleted_user: null,
        modified_user: null,
        has_delete_permission: null,
        has_update_permission: null,
        id: null,
        location: null,
        role: null,
        source_id: null,
        source_title: null,
        source_type: null,
        reply_type: null,
        status: null,
        team: null,
        title: null
    },

    delete: function (onSuccess, onError) {
        this.save(
            {},
            {
                use_id_param: true,
                type: 'DELETE',
                success: () => {
                    onSuccess();
                },
                error: () => {
                    onError();
                }
            }
        );
    },

    patch: function (fieldsToPatch, onComplete, onError) {
        this.save(fieldsToPatch, {
            patch: true,
            use_id_param: true,
            type: 'PATCH',
            success: (response) => {
                onComplete(response.attributes);
            },
            error: () => {
                onError();
            }
        });
    },

    url: function () {
        return `/api/v3/follow_up_actions/${this.get('id')}/`;
    }
});

export const FollowUpActionField = MobileMediaField.extend({
    default: {
        id: null,
        parent_upload_guid: null
    },

    initialize: function (attrs, options) {
        options = options || {};
        $.extend(this, options);

        FollowUpActionField.__super__.initialize.call(this, attrs, options);
    },

    create_field_upload_filename: function (file_entry) {
        return $f.storage.create_s3_filepath($f.active_company.id, 'follow_up_actions', null, file_entry.name);
    },

    get_parent_upload_guid: function () {
        return this.parent_upload_guid;
    }
});

export const collectCameraNative = async () => {
    const photo = await Camera.getPhoto({
        quality: 90,
        resultType: CameraResultType.Uri,
        width: MAX_SIZE,
        height: MAX_SIZE,
        source: CameraSource.Camera
    });

    return photo;
};

export const collectMediaWeb = async () => {
    return new Promise((resolve) => {
        $f.mobile.uploads.web_filestore.pick_new_file(
            {
                allowed_file_types: 'image/*',
                allow_multiple: true,
                is_media: true
            },
            async function (files_list) {
                const displayUrls = [];
                await Promise.all(
                    files_list.map(async (file) => {
                        const rawFile = file.get('raw_file');
                        const extension = rawFile.name.match(/(\.\w+$)/)?.[0];
                        const renamedFile = new File([rawFile], `${createUUID()}${extension || '.jpg'}`, {
                            type: rawFile.type
                        });
                        const resizedFile = await resizeImage(renamedFile, 2048);
                        file.set('raw_file', resizedFile);

                        const filePath = URL.createObjectURL(rawFile);
                        displayUrls.push({
                            name: rawFile.name,
                            raw_file: filePath,
                            size: resizedFile.size,
                            type: rawFile.type
                        });
                    })
                );

                resolve({ files: files_list, displayUrls });
            }
        );
    });
};

export const collectMediaNative = async () => {
    const files = await Camera.pickImages({
        quality: 90,
        width: MAX_SIZE,
        height: MAX_SIZE
    });

    if (!files || !files.photos.length) {
        return [];
    }

    return files.photos;
};

export const getZenputFiles = (files) => {
    return new ZenputFiles(
        _.map(files, function (path_or_file, i) {
            if (!path_or_file) {
                return null;
            }

            if (typeof path_or_file === 'string' && path_or_file.indexOf('://') === -1) {
                path_or_file = 'file://' + path_or_file;
            }

            var model_dict = {
                id: createUUID(i),
                mimetype: 'image/jpg'
            };

            if (typeof path_or_file === 'string') {
                model_dict.url_native = path_or_file;
            } else {
                model_dict.raw_file = path_or_file;
            }

            return model_dict;
        })
    );
};
